import React from 'react';
import { Icon, Button } from 'semantic-ui-react';
const CollapsiblePanel = ({ title, icon, children, isMinimized = false, minimizable = true, onToggle }) => {
    return (React.createElement("div", { className: "bg-white shadow-sm rounded-lg border border-gray-200 overflow-hidden" },
        React.createElement("div", { className: "p-2 border-b border-gray-200 bg-gray-50 flex justify-between items-center" },
            React.createElement("div", { className: "flex items-center" },
                icon && React.createElement(Icon, { size: "small", name: icon, className: "text-gray-500 mr-2" }),
                React.createElement("strong", null, title)),
            minimizable && (React.createElement(Button, { icon: true, basic: true, size: "mini", onClick: () => {
                    const newState = !isMinimized;
                    onToggle?.(newState);
                }, className: "!border-0 !bg-transparent hover:!bg-gray-200", title: isMinimized ? "Expand" : "Collapse" },
                React.createElement(Icon, { name: isMinimized ? "expand" : "compress" })))),
        !isMinimized && (React.createElement("div", { className: "p-4" }, children))));
};
export default CollapsiblePanel;
